import { useGetLinks, useGetStrings } from "@app/store/service/cmsService"
import { appStore } from "@app/store/store"
import { LinkTypes } from "@app/utils/constants"
import { useSelector } from "@tecreation/js-state-react"

const getLinkUrl = linkData => {
	if (appStore.get("core.kioskMode")) return linkData.kioskBaseUrl
	return linkData.baseUrl
}

export const Link = ({ href, children, onClick, noItalic, className }) => (
	<li className="list-item-no-styling">
		<a
			href={href}
			target="_blank"
			className={"color-fg-secondary mr-2 clickable " + className}
			style={{
				fontStyle: !noItalic && "italic",
			}}
			onClick={onClick}
		>
			{children}
		</a>
	</li>
)

export const LinkList = () => {
	const location = useSelector(state => state.core.location)
	const {
		data: {
			orderOverviewAGBLink,
			orderOverviewPrivacyLink,
			orderOverviewLegalNoticeLink,
			orderOverviewOrderProcessLink,
			orderOverviewPaymentsLink,
			orderOverviewDeliveryLink,
			orderOverviewDeliveryCostsLink,
			orderOverviewRevocationLink,
			usefulLinksLabel,
		},
	} = useGetStrings(undefined, { defaultData: {} })
	const { data: linkData } = useGetLinks()
	if (!linkData) {
		return null
	}

	return (
		<nav aria-label={usefulLinksLabel} className="mt-auto">
			<div className="flex flex-row flex-justify-between flex-items-baseline flex-wrap mt-auto pt-4 f6">
				<p className="color-black-700 mr-2">
					© {new Date().getFullYear()} {location ? location.company : ""}
				</p>
				<ol aria-label={usefulLinksLabel} style={{ display: "contents" }}>
					<Link href={getLinkUrl(linkData) + appStore.get("core.languageCode") + "/" + linkData.links.find(e => e.type === LinkTypes.agb).slug}>
						{orderOverviewAGBLink}
					</Link>
					<Link href={getLinkUrl(linkData) + appStore.get("core.languageCode") + "/" + linkData.links.find(e => e.type === LinkTypes.privacy).slug}>
						{orderOverviewPrivacyLink}
					</Link>
					<Link href={getLinkUrl(linkData) + appStore.get("core.languageCode") + "/" + linkData.links.find(e => e.type === LinkTypes.impressum).slug}>
						{orderOverviewLegalNoticeLink}
					</Link>
					{!appStore.get("core.kioskMode") && (
						<>
							<Link href={getLinkUrl(linkData) + appStore.get("core.languageCode") + "/" + linkData.links.find(e => e.type === LinkTypes.orderProcess).slug}>
								{orderOverviewOrderProcessLink}
							</Link>
							<Link href={getLinkUrl(linkData) + appStore.get("core.languageCode") + "/" + linkData.links.find(e => e.type === LinkTypes.payments).slug}>
								{orderOverviewPaymentsLink}
							</Link>
							<Link href={getLinkUrl(linkData) + appStore.get("core.languageCode") + "/" + linkData.links.find(e => e.type === LinkTypes.delivery).slug}>
								{orderOverviewDeliveryLink}
							</Link>
							<Link href={getLinkUrl(linkData) + appStore.get("core.languageCode") + "/" + linkData.links.find(e => e.type === LinkTypes.deliveryFee).slug}>
								{orderOverviewDeliveryCostsLink}
							</Link>
							<Link href={getLinkUrl(linkData) + appStore.get("core.languageCode") + "/" + linkData.links.find(e => e.type === LinkTypes.withdrawal).slug}>
								{orderOverviewRevocationLink}
							</Link>
						</>
					)}
				</ol>
			</div>
		</nav>
	)
}
